module.exports = __webpack_public_path__ + "media/images/team1-2b7d97ca.jpg";